module.exports = __webpack_public_path__ + "img/icon2.c174fc20.png";